import { render } from "./ModalDuelsGame.vue?vue&type=template&id=026f8b28&scoped=true"
import script from "./ModalDuelsGame.vue?vue&type=script&lang=js"
export * from "./ModalDuelsGame.vue?vue&type=script&lang=js"

import "./ModalDuelsGame.vue?vue&type=style&index=0&id=026f8b28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026f8b28"]])

export default __exports__